import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";

import { setInvoiceBuilderDuplicateInvoice } from "./actions";
import { DUPLICATE_INVOICE_WINDOW } from "utilities/dist/invoice/constants";
import { buildInvoiceNumberWithBeer } from "utilities/dist/invoice/helpers";
import { CompanyFeatures } from "utilities/dist/company/constants";
import { isCompanyFeatureActive } from "utilities/dist/company/helpers";

const DuplicateErrorModal = ({ handleProceed }) => {
    const { duplicateInvoice, isCustomerInvoiceNumberingActive } = useSelector(
        ({ invoiceBuilder, auth }) => ({
            duplicateInvoice: invoiceBuilder.duplicateInvoice,
            isCustomerInvoiceNumberingActive: isCompanyFeatureActive(
                auth.user.company,
                CompanyFeatures.CUSTOMER_INVOICE_NUMBERING
            ),
        })
    );

    const dispatch = useDispatch();
    const onDismissModal = () => dispatch(setInvoiceBuilderDuplicateInvoice(null));

    const invoiceNumber = duplicateInvoice
        ? buildInvoiceNumberWithBeer(duplicateInvoice, isCustomerInvoiceNumberingActive)
        : "";
    return (
        <Modal size="small" open={!!duplicateInvoice}>
            <Modal.Header>Duplicate invoices</Modal.Header>
            <Modal.Content>
                <p>
                    Invoice <Link to={`/invoice/${invoiceNumber}`}>#{invoiceNumber}</Link>, created
                    within the last {DUPLICATE_INVOICE_WINDOW}hrs, has the exact same items with the
                    exact same quantity of each item. Please confirm if you still want to create the
                    seemingly duplicate invoice.
                </p>
            </Modal.Content>
            <Modal.Actions>
                <Button data-cy="nevermind" positive content="Nevermind" onClick={onDismissModal} />
                <Button
                    data-cy="create_anyway"
                    color="yellow"
                    content="Create anyway"
                    onClick={handleProceed}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default DuplicateErrorModal;
